import { z } from 'zod'

const EnvSchema = z.object({
  /** Base URL for the admin API client. Must not include a trailing slash. */
  VITE_ADMIN_API_BASE_URL: z.url(),

  /**
   * Full admin API URL passed to better-auth's createAuthClient({ baseURL }). better-auth
   * appends /api/auth automatically. Must not include a trailing slash.
   */
  VITE_APP_URL: z.url(),

  /**
   * Deployment tier, baked in at build time via Docker build-arg. Gates dev-only UI (e.g.
   * the Dev Mode settings page) — defaults to "local" for `pnpm dev`.
   */
  VITE_DEPLOY_ENV: z.enum(['local', 'dev', 'uat', 'prod']).default('local'),

  /**
   * Shared "frontend" Sentry project DSN — safe to expose client-side. Leave unset to
   * disable Sentry entirely (e.g. local dev).
   */
  VITE_SENTRY_DSN: z.string().optional(),

  /** Service-prefixed release identifier, e.g. console-app@<git-sha>, set at build time. */
  VITE_SENTRY_RELEASE: z.string().default('console-app@local'),

  /**
   * Shows the TanStack Router devtools panel in dev builds. Set to "false" in
   * `.env.local` to opt out locally; has no effect outside `pnpm dev` (see __root.tsx).
   */
  VITE_SHOW_ROUTER_DEVTOOLS: z.stringbool().default(true),
})

const parsed = EnvSchema.safeParse(import.meta.env)

if (!parsed.success) {
  const errors = z.treeifyError(parsed.error).errors

  throw new Error(
    `Missing or invalid environment variables:\n ${JSON.stringify(errors, null, 2)}\n
    Check apps/console-app/.env.local — see the Doppler Secrets Management spec on Confluence for the full variable reference.`,
  )
}

export const env = parsed.data
